<template>
    <div class="container">
        <div class="breadCrumpWrap">
            <span class="backBtn" @click="back"> <i class="el-icon-arrow-left"></i> 返回</span>
            <div class="itemBox">
                <span>
                    <span class="name">{{breadShowName}}</span>
                    <span class="lineIcon">&gt;</span>
                    <span class="name">库存列表</span>
                </span>
            </div>
        </div>
        <div class="searchBox">
           <div class="left">
                <el-form :inline="true">
                    <el-form-item>
                        <el-input placeholder="ID/商品名称/款号" size="medium" v-model="formObj.fuzzyQuery" clearable></el-input>
                    </el-form-item>
                    <el-form-item>
                        <el-button icon="el-icon-search" size="medium" type="primary" @click="fuzzySearchClick">查询</el-button>
                    </el-form-item>
                </el-form>
            </div>
            <div class="right">
                <el-button type="primary" size="medium" @click="openUploadStockPop">上传库存列表</el-button>
                <el-button type="primary" size="medium" @click="download" v-loading="importLoading">导出库存列表</el-button>
            </div>
        </div>
        <div class="tableBox stock-table" >
            <el-table
                :data="tableData"
                :span-method="objectSpanMethod"
                border
                size="small"
                v-loading="isLoading"
            >
                <el-table-column
                    label="序号"
                    width="50"
                    align="center"
                >
                    <template slot-scope="scope">
                        {{ total - searchObj.num * (searchObj.page-1) - scope.row.index }}
                    </template>
                </el-table-column>
                <el-table-column
                    prop="item_id"
                    label="ID"
                    width="80"
                >
                </el-table-column>
                <el-table-column
                    prop="pic"
                    label="图片"
                    width="100"
                >
                    <template slot-scope="scope">
                        <el-image
                            style="width: 64px; height: 64px"
                            :src="scope.row.mallItemFileUrl"
                            fit="cover"
                        >
                        </el-image>
                    </template>
                </el-table-column>
                <el-table-column
                    prop="itemName"
                    label="商品名称"
                    min-width="120"
                >
                </el-table-column>
                <el-table-column
                    prop="brandName"
                    label="品牌"
                    min-width="120"
                >
                </el-table-column>
                <el-table-column
                    prop="styleNumber"
                    label="款号"
                    min-width="120"
                >
                </el-table-column>

                <el-table-column
                    prop="stock"
                    :label="'可销总数\nSPU'"
                    min-width="100"
                >
                </el-table-column>

                <el-table-column
                    prop="color"
                    :label="'颜色'"
                    min-width="80"
                >
                </el-table-column>
                <el-table-column
                    prop="colorStock"
                    :label="'可销库\n存小计'"
                    min-width="80"
                >
                </el-table-column>
                <el-table-column
                    prop="size"
                    :label="'尺码'"
                    min-width="80"
                >
                </el-table-column>
                <el-table-column
                    prop="number"
                    :label="'可销库存'"
                    min-width="80"
                >
                </el-table-column>
               
                <el-table-column
                    label="操作"
                    min-width="180"
                >
                    <template slot-scope="scope">
                        <el-button type="text" size="small" @click="toDetailPage(scope.row)">查看商品</el-button>
                        <el-button type="text" size="small" @click="toEditStock(scope.row)">修改库存</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div class="pageBox">
            <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page.sync="searchObj.page"
                :page-size.sync="searchObj.num" layout="total, sizes, prev, pager, next, jumper" :total="total"
                background>
            </el-pagination>
        </div>
        <!-- <div class="ceshi">
			ceshi:
			{{searchObj}}
		</div> -->

        <el-dialog
            title="上传库存表格"
            :visible.sync="uploadStockPop"
            width="600px"
            :close-on-click-modal="false"
            class="upload-stock-pop"
        >
            <el-upload
                class="upload-stock"
                drag
                name="upload_file"
                :action="uploadStockFileApi"
                :data="uploadStockData"
                :show-file-list="false"
                accept=".xlsx,.xls"
                :on-progress="onProgress"
                :on-success="uploadStockSuccess"
                :on-error="uploadStockFail"
                :before-upload="beforeUploadStock"
            >
                <i class="el-icon-upload"></i>
                <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
                <div class="el-upload__tip" slot="tip">
                    只能上传excel文件, 上传模板示例下载：
                    <a :href="uploadExampleLink">库存修改上传表格-模板.xlsx</a>
                </div>
            </el-upload>
            <div class="progress-wrap" v-if="uploadLoading">
                <div class="progress-bar">
                    <div class="progress-bar-inner" :style="{width: uploadProgress + '%'}"></div>
                </div>
                <div class="text">正在上传...</div>
            </div>
        </el-dialog>

        <el-dialog
            title="上传错误提示"
            :visible.sync="uploadStockErrorTip"
            width="600px"
            :close-on-click-modal="false"
            class="upload-stock-error-pop"
        >
            <div class="err-tip">{{uploadStockError.msg}}</div>
            <div>
                <el-table
                    :data="uploadStockError.data"
                    border
                    style="width: 100%"
                >   
                    <el-table-column
                        type="index"
                        width="50">
                    </el-table-column>
                    <el-table-column
                        prop="brandName"
                        label="品牌">
                    </el-table-column>
                    <el-table-column
                        prop="styleNumber"
                        label="款号">
                    </el-table-column>
                </el-table>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    import {
        json,
        wordData
    } from '@/common/common.js'
    import {
        ajaxPost, api, ajaxLogin
    } from '@/common/request.js'
    import {
        utils
    } from '@/common/common.js'
    import {
      getSignStr
    } from '@/common/tool.js'
    import {
      ajaxImport, importApi
    } from '@/common/request_import.js'
    import { saveAs } from 'file-saver'
    import moment from 'moment'
    export default {
        name: 'adminIndex',
        data() {
            return {
                importLoading:'',
                lastPage:'',
                newLinkParamObj:{},
                isShowAddOrderModal:false,
                isLoading: false,
                msg: 'Welcome to Your Vue.js App',
                formObj: {
                    fuzzyQuery: '',
                },
                searchObj: {
                    page: 1,
                    num: 10,
                },
                //表格
                tableData: [],
                multipleSelection: [],
                //分页
                total: 0,
                currentAuthList: "12312312312312",
                isShowModal: false,
                downloadUrl:'',

                // 用户数据
                userData: {},
                breadShowName: '',

                // 上传库存表格相关
                uploadStockPop: false,
                uploadStockFileApi: importApi + 'digital_warehouse_php/?s=stock&op=import',
                uploadStockData: {
                    user_id: ''
                },
                uploadLoading: false,
                uploadProgress: 0, 

                uploadStockErrorTip: false,
                uploadStockError: {
                    msg: '',
                    data: []
                },
                uploadExampleLink: api.imgPrev + 'static/digital_warehouse/%E5%BA%93%E5%AD%98%E4%BF%AE%E6%94%B9%E4%B8%8A%E4%BC%A0%E8%A1%A8%E6%A0%BC-%E6%A8%A1%E6%9D%BF.xlsx',

            }
        },
        computed: {
            IMG_PREV() {
                return api.imgPrev
            },
            adminId() {
                return utils.getAdminId()
            },
            token(){
              return utils.getToken()
            },

        },
        watch: {
            $route: {
                handler: function(route) {
                    this.searchObj.num = Number(this.$route.query.size)
                    ? Number(this.$route.query.size)
                    : 10;
                    this.searchObj.page = Number(this.$route.query.page)
                    ? Number(this.$route.query.page)
                    : 1;
                    this.formObj.fuzzyQuery = this.$route.query.search || "";
                    this.getTableLists();
                },
                immediate: true
            }
        },
        components: {

        },
        methods: {
            // 导出库存列表
            download() {
                let _this = this
                if(_this.importLoading){
                    _this.$message({
                        message: "正在下载中，请耐心等待", //接口返回一个页面
                        type: 'warning',
                        duration: 1500
                    });
                    return false
                }
                let tokenArg={
                    token:this.token,
                    adminId:this.adminId,
                    userId:this.$route.query.userId,
                }
                ajaxLogin('/admin/user/getTokenByAdmin', tokenArg).then((res) => {
                    console.log(res)
                    if (res.errorCode == 200) {
                        let userId= this.$route.query.userId
                        let token= res.data.token_info
                        let image_type="12104"//12101为原图，12102为大图，12104为缩略图
                        let item_state=""   //商品状态，0为无效（删除），1为有效（上架），2为有效但不展示（下架），留空为全量导出
                        var signArg={
                            user_id: userId,
                            user_token: token,
                            image_type:image_type,
                            item_state:item_state,
                        }
                        var signStr=getSignStr(signArg)
                        var arg = {
                            user_id: userId,
                            user_token: token,
                            image_type:image_type,
                            item_state:item_state,
                            sign:signStr
                        };
                        var url = '/digital_warehouse_php/?s=stock&op=export'
                        _this.importLoading=true
                        ajaxImport(url, arg).then(function(res) {
                            console.log(res)
                            _this.importLoading=false
                            if(res.error_code=='0'){
                                _this.$message({
                                    message: "下载库存列表成功", //接口返回一个页面
                                    type: 'success',
                                    duration: 2000
                                });
                                saveAs(res.data.file, `zciiss数字云仓_${_this.breadShowName}_商品库存_${moment().format("YYYY年MM月DD日HH时mm分")}`);
                            }else{
                                _this.$message({
                                    message: res.error_msg||"请求报错", //接口返回一个页面
                                    type: 'error',
                                    duration: 1500
                                });
                            }
                        }).catch((res) => {
                            _this.importLoading=false
                        })
                    } else {
                        _this.importLoading=false
                        _this.$message({
                            message: res.errorMsg || "请求报错", //接口返回一个页面
                            type: 'error',
                            duration: 1500
                        });
                    }
                }).catch(err => {
                    console.log(err)
                    _this.importLoading=false
                })
            },

            // 上传库存表格  start
            openUploadStockPop() {
                this.uploadStockPop = true
            },
            beforeUploadStock(file) {
                console.log(file);

                const isExcel = file.type == 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
                || file.type == 'application/vnd.ms-excel';
                const isLimit = file.size / 1024 / 1024 < 20;
                if (!isExcel) {
                    this.$message.error("请上传Excel格式的文件!");
                    return false
                }
                if (!isLimit) {
                    this.$message.error("上传Excel大小不能超过 20MB!");
                    return false
                }
                this.uploadLoading = true
                this.uploadProgress = 0
                return isExcel && isLimit;
            },
            onProgress(e, file, fileList) {
                console.log(e, file, fileList)
                this.uploadProgress = e.percent
            },
            uploadStockSuccess(res, file) {
                setTimeout(() => {
                    this.uploadLoading = false
                    console.log(res, file);
                    if (res.error_code == 0) {
                        this.uploadStockPop = false
                        this.$message.success('上传成功！')
                        this.getTableLists()
                    } else if (res.error_code == -2) {
                        this.uploadStockErrorTip = true;

                        this.uploadStockError.msg = res.error_msg
                        this.uploadStockError.data = res.data
                    } else {
                        this.$message({
                            showClose: true,
                            message: res.error_msg || '网络异常',
                            type: 'error',
                            duration: 8000
                        })
                        // this.$message.error(res.error_msg || '网络异常')
                    }
                }, 500)
            },
            uploadStockFail(err) {
                console.log(err)
                setTimeout(() => {
                    this.uploadLoading = false
                    this.$message.error('上传失败！')
                }, 500)
            },
            // 上传库存表格  end


            // 返回
            back() {
                this.$router.back()
            },
            fuzzySearchClick() {
                this.searchObj.page = 1;
                this.updateRouter();
            },
            updateRouter() {
                this.$router
                    .push(
                    "/stock/list?search=" +
                        this.formObj.fuzzyQuery +
                        "&page=" +
                        this.searchObj.page +
                        "&size=" +
                        this.searchObj.num +
                        "&userId=" +
                        this.$route.query.userId
                    )
            },
            getDetail(){
                // 查询基本信息
                ajaxPost('/admin/getDwUserInfo', {
                    userId: this.$route.query.userId
                }).then(res => {
                    console.log(res)
                    if(res.errorCode==200){
                        this.userData = res.data[0]
                        this.breadShowName = res.data[0].user_organization_name || res.data[0].user_individual_name
                    }else{
                    }
                }).catch(err => {
                    console.log(err)
                })
            },
            getTableLists() {
                let _this = this
                this.isLoading = true
                ajaxPost('/commodity/getStockList', {
                    fuzzyQuery: this.formObj.fuzzyQuery,
                    page: this.searchObj.page,
                    num: this.searchObj.num,
                    userId: this.$route.query.userId,
                }).then((res) => {
                    console.log('/commodity/getStockList', res)
                    this.isLoading = false
                    if (res.errorCode == 200) {
                        let tableData = []
                        res.data.mallItemList.forEach((item, item_index) => {
                            try {
                                let sizeArrObj = JSON.parse(item.sizeArr)
                                let sizeArr = sizeArrObj.group
                                let stockSpan = sizeArr.reduce((sum, span) => {
                                    return sum + span.sizeArr.length
                                }, 0)
                                sizeArr.forEach((ele, ele_index, ele_array) => {
                                    let colorStock = ele.sizeArr.reduce((sum, num) => {
                                        return sum + num.number
                                    }, 0)
                                    
                                    let t = ele.sizeArr.map((size, size_index, size_array) => {
                                        let colorSpan = 0
                                        if (!(ele_index == 0 && size_index == 0)) {
                                            stockSpan = 0
                                        } 
                                        if (size_index == 0) {
                                            colorSpan = size_array.length
                                        }
                                        return {
                                            index: item_index,
                                            itemName: item.itemName,
                                            itemState: item.itemState,
                                            itemUnqueNumber: item.itemUnqueNumber,
                                            item_id: item.item_id,
                                            mallItemFileUrl: this.IMG_PREV + item.mallItemFileUrl,
                                            price: item.price,
                                            styleNumber: item.styleNumber,
                                            user_id: item.user_id,
                                            stock: item.stock,
                                            stockSpan: stockSpan,
                                            color: ele.color,
                                            colorSpan: colorSpan,
                                            colorStock: colorStock,
                                            size: size.name,
                                            number: size.number,
                                            brandName: item.brandName
                                        }
                                    })
                                    tableData = tableData.concat(t)
                                })
                            } catch (error) {
                                console.log(error)
                                tableData = tableData.concat({
                                    index: item_index,
                                    itemName: item.itemName,
                                    itemState: item.itemState,
                                    itemUnqueNumber: item.itemUnqueNumber,
                                    item_id: item.item_id,
                                    mallItemFileUrl: item.mallItemFileUrl? this.IMG_PREV + item.mallItemFileUrl:'',
                                    price: item.price || '/',
                                    styleNumber: item.styleNumber,
                                    user_id: item.user_id,
                                    stock: item.stock || '0',
                                    stockSpan: 1,
                                    color: '/',
                                    colorSpan: 1,
                                    colorStock: '/',
                                    size: '/',
                                    number: '/'
                                })
                            }
                            
                        });
                        console.log(tableData)
                        this.tableData = tableData
                        this.total = parseInt(res.data.totalCount)
                    } else if (res.errorCode == -10111) {
                        // 暂无商品列表
                        this.tableData = []
                        this.total = 0
                        this.$message.error(res.errorMsg || '暂无商品列表')
                    } else {
                        this.$message.error(res.errorMsg || '获取列表数据失败')
                    }
                }).catch(err => {
                    this.isLoading = false
                })
            },
            // 合并表格
            objectSpanMethod({ row, column, rowIndex, columnIndex }) {
                //   console.log(row, column, rowIndex, columnIndex)
                
                if (columnIndex == 7 || columnIndex == 8) {
                    if (row.colorSpan && row.colorSpan >= 1) {
                            return {
                                rowspan: row.colorSpan,
                                colspan: 1
                            };
                    } else {
                        return {
                            rowspan: 0,
                            colspan: 0
                        };
                    }
                }
                if (columnIndex <= 6 || columnIndex == 11) {
                    if (row.stockSpan && row.stockSpan >= 1) {
                            return {
                                rowspan: row.stockSpan,
                                colspan: 1
                            };
                    } else {
                            return {
                                rowspan: 0,
                                colspan: 0
                            };
                    }
                }
            },
            handleSizeChange(size) { //分页：每页n条
                this.searchObj.num = size
                this.searchObj.page = 1
                this.updateRouter()
            },
            handleCurrentChange(page) { //分页：改变第n页
                this.searchObj.page = page
                this.updateRouter()
            },
            toDetailPage (item) {
                this.$router.push('/goods/detail?id='+ item.item_id +'&userId=' + item.user_id)
            },
            toEditStock (item) {
                this.$router.push('/stock/edit?id='+ item.item_id +'&userId=' + item.user_id)
            },
        },
        created() {
            this.getDetail();
            this.uploadStockData.user_id = this.$route.query.userId
            let sign = getSignStr(this.uploadStockData)
            this.uploadStockData.sign = sign
        },
    }
</script>

<style scoped lang="scss">
    .searchBox {
        padding: 16px 20px 0;
        .left {
            float: left;
        }
        .right {
            float: right;
        }
    }

    .searchBox:after {
        content: "";
        display: block;
        clear: both;
    }
    .tableBox {
        padding: 10px 20px;
    }
    .breadCrumpWrap {
        display: flex;
        font-size: 12px;
        color: #606266;
        padding: 10px 20px 8px;

        .backBtn {
            color: #333;
            border: 1px solid #ddd;
            font-size: 12px;
            border-radius: 4px;
            padding: 3px 5px;
            cursor: pointer;
            background: #fff;
            margin-right: 20px;
            display: inline-block;
            vertical-align: text-bottom;
        }

        .backBtn:hover {
            background: #ddc
        }

        .itemBox {
            line-height: 24px;
            .name:hover,.name.active{color:royalblue;cursor: pointer}
            .disabled.name{color:#999}
            .disabled.name:hover{cursor:not-allowed}
        }
        .lineIcon{padding:0 3px;}
    }

    .upload-stock {
        text-align: center;
        padding: 16px 0;
    }
    .progress-wrap {
        position: absolute;
        width: 100%;
        height: 100%;
        left: 0;
        top: 0;
        background: rgba($color: #ffffff, $alpha: 0.9);
    
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;

        .progress-bar {
            width: 400px;
            height: 30px;
            background: #ccc;
            border-radius: 6px;
            overflow: hidden;
            position: relative;
        }
        .progress-bar-inner {
            position: absolute;
            left: 0;
            top: 0;
            width: 0;
            height: 30px;
            background: #F56C6C;
            transition: width 0.5s;
        }
        .text {
            font-size: 13px;
            color: #333;
            margin-top: 12px;
        }
    }
    .upload-stock-error-pop {
        .err-tip {
            font-size: 14px;
            color: #F56C6C;
            font-weight: bold;
            margin-bottom: 20px;
        }
    }
</style>



// WEBPACK FOOTER //
// src/pages/stock/list.vue